import gql from 'graphql-tag';

const GET_STUDENT_ENGAGEMENT_REPORT = gql`
  query getPrmStudentEngagementReport($where: PrmStudentEngagementReportWhereInput!) {
    prmStudentEngagementReport(where: $where) {
      studentCurriculumProgress {
        studentId
        student {
          id
          firstName
          lastName
        }
        lessonCompletionStats {
          metSkillWithSupportCount
          metSkillWithoutSupportCount
          unmetSkillCount
        }
      }
    }
  }
`;

export default GET_STUDENT_ENGAGEMENT_REPORT;
